import React from 'react';
import {Header} from './Header';
import {Content} from './Content';
import Loader from '../../Common/components/Loader';
import {Record} from '../../../../../../stores/Form/Record';
import {priority} from '@priority-software/priority-proto-api/lib';
import {SettingsPanelCol} from '../../Common/consts';

type Props = {
    files: Record[];
    parentTitle: string;
    isLoading: boolean;
    shouldFetchMore: boolean;
    enabledCols: string[];
    applySettings: (cols: SettingsPanelCol[]) => Promise<void>;
    subformType: priority.netitems.form.SubformType;
    formTitle: string;
    fastSearchQuery: string;
    setParentNeedsRefresh: (arg: boolean) => void;
};

export const Attachments = ({
    files,
    parentTitle,
    isLoading,
    shouldFetchMore,
    enabledCols,
    applySettings,
    subformType,
    formTitle,
    fastSearchQuery,
    setParentNeedsRefresh
}: Props) => {
    return isLoading ? (
        <Loader />
    ) : (
        <>
            <Header
                parentTitle={parentTitle}
                filesNum={files?.length}
                isLoading={isLoading}
                shouldFetchMore={shouldFetchMore}
                formTitle={formTitle}
            />
            <Content
                files={files}
                shouldFetchMore={shouldFetchMore}
                fastSearchQuery={fastSearchQuery}
                enabledCols={enabledCols}
                applySettings={applySettings}
                subformType={subformType}
                setParentNeedsRefresh={setParentNeedsRefresh}
            />
        </>
    );
};
